export interface Testimonial {
  logoSrc: string;
  quote: string;
  author: string;
  authorTitle: string;
}

export const TESTIMONIALS_FIRST_COLUMN: Testimonial[] = [
  {
    logoSrc:
      'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments-dev/generic_asset/asset/946a5b8de07f7955c5d453cc3ff49de9-1752673248417/Senia-logo.png',
    quote:
      'We use Fiverr for everything from videography to logo design, social media marketing, and 3D design. Our main 3D product designer previously worked for Cartier! The turnaround time is so fast.',
    author: 'Christina Senia & Gina Senia',
    authorTitle: 'Co-Founders',
  },
  {
    logoSrc:
      'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments-dev/generic_asset/asset/946a5b8de07f7955c5d453cc3ff49de9-1752673248435/Vontelle-logo.png',
    quote:
      'When people ask us, I say I have 20 people. That works for me because I include the 10 people at Fiverr. Those people are working for you as your team, and they want you to have the best of the best.',
    author: 'Nancy Harris',
    authorTitle: 'Co-Founder',
  },
];

export const TESTIMONIALS_SECOND_COLUMN: Testimonial[] = [
  {
    logoSrc:
      'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments-dev/generic_asset/asset/9eaf90b7e6cc07664631c71e073bb631-1752673714828/Morningcrunch-ogo.png',
    quote:
      "Fiverr gives us three things - It's the speed that moves us forward, it's the quality that we need for our work, and it's a network of trusted freelancers that we can work with in the long term.",
    author: 'Gregor Becker & Paul Ostwald',
    authorTitle: 'Founders',
  },
  {
    logoSrc:
      'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments-dev/generic_asset/asset/946a5b8de07f7955c5d453cc3ff49de9-1752673248440/PolyAI-logo.png',
    quote: "Fiverr has made it really quick and easy to find talent that matches the projects that we're working on.",
    author: 'Nathan Lieu',
    authorTitle: 'VP of Deployments',
  },
  {
    logoSrc:
      'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments-dev/generic_asset/asset/946a5b8de07f7955c5d453cc3ff49de9-1752673248431/Midnight-logo.png',
    quote: 'Fiverr allows us to take our dreams and make them a reality.',
    author: 'Natosha & Lloyd Jones',
    authorTitle: 'Founders',
  },
];

export const TESTIMONIALS_THIRD_COLUMN: Testimonial[] = [
  {
    logoSrc:
      'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments-dev/generic_asset/asset/946a5b8de07f7955c5d453cc3ff49de9-1752673248427/Alianza-logo.png',
    quote:
      'Fiverr swiftly connected us with an amazing team of marketing strategists and content creators who truly understand social impact.',
    author: 'Kristin Van Busum',
    authorTitle: 'CEO & Co-Founder',
  },
  {
    logoSrc:
      'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments-dev/generic_asset/asset/946a5b8de07f7955c5d453cc3ff49de9-1752673248425/Scripe-logo.png',
    quote:
      'Working with Fiverr freelancers saved us about 40 hours—time we could instead invest into building our product.',
    author: 'Eva Johanna Egg & Christoph Meise',
    authorTitle: 'Co-Founders',
  },
];
